/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'task': {
    width: 200.195,
    height: 200,
    viewBox: '0 0 1025 1024',
    data: '<defs/><path pid="0" d="M585.143 804.571h365.715V731.43H585.143v73.142zM365.715 512h585.143v-73.143H365.715V512zm365.714-292.571h219.429v-73.143H731.429v73.143zM1024 694.857v146.286q0 14.848-10.825 25.746t-25.746 10.825H36.572q-14.848 0-25.746-10.825T0 841.143V694.857q0-14.848 10.826-25.746t25.746-10.825h950.857q14.848 0 25.746 10.825T1024 694.857zm0-292.571V548.57q0 14.848-10.825 25.747t-25.746 10.825H36.572q-14.848 0-25.746-10.825T0 548.57V402.286q0-14.848 10.826-25.747t25.746-10.825h950.857q14.848 0 25.746 10.825T1024 402.286zm0-292.572V256q0 14.848-10.825 25.746t-25.746 10.825H36.572q-14.848 0-25.746-10.825T0 256V109.714q0-14.848 10.826-25.746t25.746-10.825h950.857q14.848 0 25.746 10.825T1024 109.714z"/>'
  }
})
